import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from './redux/store';
import './app.css';
import Routes from './routes/Routes';

const App = () => {
    // Read the topbarTheme from layout settings
    const { topbarTheme } = useSelector((state: RootState) => state.Layout);
    const isDark = topbarTheme === 'dark';

    useEffect(() => {
        const themeLink = document.getElementById('app-theme-stylesheet');
        if (themeLink) {
            const themeHref = isDark ? '/theme-dark.css?v=1.0.3' : '/theme-light.css?v=1.0.3';
            themeLink.setAttribute('href', themeHref);
        }
    }, [isDark]);

    return (
        <div className="app-scale">
            <Routes />
        </div>
    );
};

export default App;
